import SalesforceChat from "@shared/services/salesforce_chat";

var ctrl = function ($scope) {
  $scope.startChat = function () {
    SalesforceChat.open();
  };
};

ctrl.$inject = ["$scope"];

tiz.directive("chatWithSupportLink", function () {
  return {
    restrict: "E",
    controller: ctrl,
    scope: {
      message: "@",
      brandprimary: "@?",
    },
    templateUrl: require("../templates/chat_with_support_link/chat_with_support_link.html"),
  };
});
